import { render } from "./QuestionsPage.vue?vue&type=template&id=8f9b7c16"
import script from "./QuestionsPage.vue?vue&type=script&lang=js"
export * from "./QuestionsPage.vue?vue&type=script&lang=js"

import "./QuestionsPage.vue?vue&type=style&index=0&id=8f9b7c16&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__